export const WebToTextConstants = {
  DIALOG_TITLE: 'Hello! 👋',
  DIALOG_TEXT_DESKTOP: 'Ask us a question and we’ll text you back.',
  DIALOG_TEXT_MOBILE: 'Have a question? Message us here!',
  HEADER_TITLE: 'We’ll text you',
  HEADER_DESCRIPTION: 'Enter your info and we’ll text you shortly.',
  MESSAGE_SENT_HEADER_TITLE: 'Message sent!',
  MESSAGE_SENT_HEADER_DESCRIPTION: 'We’ll text you shortly.',
  MESSAGE_SENT_SUCCESS_TITLE: 'Your message has been sent.',
  MESSAGE_SENT_SUCCESS_DESCRIPTION: 'A member of our team will respond as soon as they are available. Please look for a message from',
  MESSAGE_SENT_SUCCESS_INQUIRIES_DESCRIPTION: 'For urgent inquiries call',
  MESSAGE_SENT_SUCCESS_EMERGENCIES_DESCRIPTION: 'For emergencies call 911.',
  MESSAGE_FAILED_HEADER_TITLE: 'Uh oh...',
  MESSAGE_FAILED_HEADER_DESCRIPTION: 'Something went wrong.',
  MESSAGE_FAILED_BODY_TITLE: 'System error, please try again later.',
  PATIENT_TYPE: {
    NEW: 'New Patient',
    RETURNING: 'Returning Patient',
    OTHER: 'Other'
  },
  ORIGIN_WEBTOTEXT: 'WEBTOTEXT',
  PHONE_NUMBER_MASK: '(###) ###-####',
  FEATURE_SLUG: 'WEBTOTEXT',
  DEFAULT_BACKGROUND_COLOR: '#656E8B',
  DEFAULT_TEXT_COLOR: '#FFFFFF',
  WIDGET_ID: '9257718d-b973-49c2-a05a-64baacb5d34a',
  WIDGET_SHOW_EVENT: 'pp-show-floating-widget',
  WIDGET_HIDE_EVENT: 'pp-hide-floating-widget'
}
